export type EventAnalysticTrack = string | { name: string; properties?: Record<string, unknown> }

export const parseEventTrack = (event: EventAnalysticTrack) => {
  if (typeof event === 'string') {
    return { name: event, properties: undefined }
  }

  return event
}
